var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('page-main',{ref:"main",attrs:{"tree-data":_vm.treeData},on:{"submit":_vm.reload}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }